/**
 * Per-module recording settings. Modules added later carry their own mode/capture;
 * modules parsed from the original script fall back to the project settings.
 */

export const PITCH_CAPTURE_OPTIONS = [
  { id: 'audio', label: 'Audio only' },
  { id: 'camera', label: 'Camera + audio' },
  { id: 'screen', label: 'Screen share + audio' },
];

export const PITCH_MODE_OPTIONS = [
  { id: 'teleprompter', label: 'Teleprompter' },
  { id: 'freestyle', label: 'Independent audio' },
];

export function projectDefaultCapture(project) {
  if (project?.screen_share_enabled) return 'screen';
  if (project?.camera_enabled) return 'camera';
  return 'audio';
}

export function resolveSegmentConfig(segment, project) {
  const hasOwnCapture = segment != null && ['audio', 'camera', 'screen'].includes(segment?.capture);
  let capture = hasOwnCapture ? segment.capture : projectDefaultCapture(project);
  const recordingMode = segment?.recording_mode === 'freestyle' || segment?.recording_mode === 'teleprompter'
    ? segment.recording_mode
    : (project?.recording_mode === 'freestyle' ? 'freestyle' : 'teleprompter');

  const hasOwnSpeaker = segment != null && Object.prototype.hasOwnProperty.call(segment, 'speaker_camera');
  const hasOwnSystem = segment != null && Object.prototype.hasOwnProperty.call(segment, 'system_audio');

  // Explicit non-screen capture on a scene wins over project speaker/system defaults.
  const inheritExtras = !hasOwnCapture || capture === 'screen';
  let speakerCamera = hasOwnSpeaker
    ? Boolean(segment.speaker_camera)
    : (inheritExtras && Boolean(project?.speaker_camera_enabled));
  let systemAudio = hasOwnSystem
    ? Boolean(segment.system_audio)
    : (inheritExtras && Boolean(project?.system_audio_enabled));

  // Speaker cam / system audio require a screen-share take for this scene.
  if ((speakerCamera || systemAudio) && capture !== 'screen') {
    capture = 'screen';
  }
  if (capture !== 'screen') {
    speakerCamera = false;
    systemAudio = false;
  }

  return { capture, recordingMode, speakerCamera, systemAudio };
}

export function captureLabel(capture) {
  return PITCH_CAPTURE_OPTIONS.find((o) => o.id === capture)?.label || 'Audio only';
}
